import { render, staticRenderFns } from "./imgListModule.vue?vue&type=template&id=06fbaabc&scoped=true"
import script from "./imgListModule.vue?vue&type=script&lang=js"
export * from "./imgListModule.vue?vue&type=script&lang=js"
import style0 from "./imgListModule.vue?vue&type=style&index=0&id=06fbaabc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fbaabc",
  null
  
)

export default component.exports